import React, { useState } from "react";
import AccountStyle from "./style";
import { Col, Divider, Drawer, Row, Switch } from "antd";
import InterviewIcon from "../../../assets/Icons/interview.png";
import TymeplusPay from "../../../assets/Icons/TymeplusPay.svg";
import TymeplusHr from "../../../assets/Icons/TymeplusHR.svg";
import TymeplusCRM from "../../../assets/Icons/CRM.svg";
import zoomIcon from "../../../assets/Icons/zoom.png";
import teamsIcon from "../../../assets/Icons/teamsIcon.png";
import { SettingOutlined, ExportOutlined } from "@ant-design/icons";

const Integration = () => {
  const [editDrawer, setEditDrawer] = useState(false);
  const showDrawer = () => {
    setEditDrawer(true);
  };
  const onCloseDrawer = () => {
    setEditDrawer(false);
  };
  const ConferenceCard = [
    {
      img: InterviewIcon,
      title: "Integrated video conference",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
    {
      img: zoomIcon,
      title: "Integrated video conference",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
    {
      img: teamsIcon,
      title: "Integrated video conference",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
  ];

  const AppsCard = [
    {
      img: TymeplusHr,
      title: "TymeplusHr",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
    {
      img: TymeplusCRM,
      title: "TymeplusCRM",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
    {
      img: TymeplusPay,
      title: "TymeplusPay",
      content:
        "Your account features a native BigBlueButton integration by default (with some limitations).",
    },
  ];

  return (
    <>
      <AccountStyle>
        <h2>WEB CONFERENCING</h2>
        <Divider className="ant_divider_horizontal" />
        <span className="strict-content">
          Only one conference tool can be enabled.
        </span>

        <Row className="conference_media_container" gutter={12}>
          {ConferenceCard.map((item, index) => {
            return (
              <Col key={index} xl={8}>
                <div className="conference_media_box">
                  <div className="conference_media_img">
                    <div className="media_img_outer_box">
                      <img src={item.img} alt={item.title} />
                    </div>
                    <SettingOutlined
                      className="media_setting_icon"
                      onClick={showDrawer}
                    />
                  </div>
                  <p className="media_title">{item.title}</p>
                  <p className="media_content">{item.content}</p>
                </div>
              </Col>
            );
          })}
        </Row>
        <br></br>
        <h2>APPS</h2>
        <Divider className="ant_divider_horizontal" />

        <Row className="conference_media_container" gutter={12}>
          {AppsCard.map((item, index) => {
            return (
              <Col key={index} xl={8}>
                <div className="conference_media_box">
                  <div className="conference_media_img">
                    <div className="media_img_outer_box">
                      <img src={item.img} alt={item.title} />
                    </div>
                    <ExportOutlined className="media_setting_icon" />
                  </div>
                  <p className="media_title">{item.title}</p>
                  <p className="media_content">{item.content}</p>
                </div>
              </Col>
            );
          })}
        </Row>

        <Drawer
          title="Zoom Webinar integration"
          onClose={onCloseDrawer}
          open={editDrawer}
          width={600}
        >
          <AccountStyle>
            <div className="enable_switch_container">
              <div className="enable_switch">
                <Switch />
              </div>
              <div className="enable_switch_content">
                <p>Enable</p>
                <p>
                  This will allow you to create online meetings with your Zoom
                  Webinar tool. Learn more
                </p>
              </div>
            </div>
          </AccountStyle>
        </Drawer>
      </AccountStyle>
    </>
  );
};

export default Integration;
